import { render, staticRenderFns } from "./Corporation.vue?vue&type=template&id=9022c67e&scoped=true"
import script from "./Corporation.vue?vue&type=script&lang=js"
export * from "./Corporation.vue?vue&type=script&lang=js"
import style0 from "./Corporation.vue?vue&type=style&index=0&id=9022c67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9022c67e",
  null
  
)

export default component.exports